'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/*\n* ink colors (with variations only for black and white)\n*/\n.login__header {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  position: relative;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n}\n.login__header .title {\n  font-size: 18px;\n  line-height: 28px;\n  font-weight: 700;\n  margin: 0;\n  padding: 0;\n  color: #ffffff;\n}\n.login__header .title__modal {\n  font-size: 18px;\n  line-height: 28px;\n  font-weight: 700;\n  margin: 0 0 calc(0.75 * 1rem);\n  padding: 0 0 calc(0.75 * 1rem);\n}\n.login__header .back {\n  display: flex;\n  border-radius: 50px;\n  background-color: #ffffff;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 40px;\n  position: absolute;\n  left: 0;\n  cursor: pointer;\n}\n.login__header .back--modal {\n  display: flex;\n  border-radius: 50px;\n  background-color: #ffffff;\n  border: 1px solid #1D66DD;\n  justify-content: center;\n  align-items: center;\n  width: 25px;\n  height: 25px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  cursor: pointer;\n}\n.login__header .back--modal i {\n  left: -6px;\n}\n.login__header .close-btn {\n  font-size: 18px;\n  line-height: 28px;\n  font-weight: 400;\n  position: absolute;\n  top: -3px;\n  right: 0;\n  border: none;\n  background: none;\n  cursor: pointer;\n}");
//# sourceMappingURL=Header.scss.js.map
